import type { ListTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const listDark: ListTheme = {
  name: 'List',
  common: commonDark,
  self
}

export default listDark
